import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import errorImage from "../assets/no_image.jpg";

const ImageGallery = ({ allImages }) => {
  const [visibleImages, setVisibleImages] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const loader = useRef(null);

  const IMAGES_PER_PAGE = 50;

  const handleError = (e) => {
    e.target.onerror = null;
    e.target.src = errorImage;
  };

  useEffect(() => {    
    const loadImages = () => {
      const newImages = allImages.slice(0, page * IMAGES_PER_PAGE);
      setVisibleImages(newImages);
    };
    loadImages();
  }, [page, allImages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setPage((prev) => prev + 1);
        }
      },
      { threshold: 1 }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) observer.unobserve(loader.current);
    };
  }, []);

  return (
    <>
      {visibleImages.map((item, index) => (
        <Link to={`/live_casinoInPlay/${item._id}`}
          className='game-img'
          key={index}
          id={`${index}_${item._id}`}
          onClick={() => navigate(`/casinoInPlay/${item._id}`)}
        >
          <img key={index} src={item.url_thumb} onError={handleError} alt={item.game_name} />
        </Link>
      ))}
      <div ref={loader}/>
    </>
  );
};

export default ImageGallery;
